var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-full"},[(_vm.modelSettings.cloudRenderVersion === 5)?_c('locationSettingVulkan',{attrs:{"moduleName":_vm.moduleName}}):_c('locationSetting',{attrs:{"moduleName":_vm.moduleName}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }